export const PERMISSIONS_INFO_KEY = "permissions_info";

export const DASHBOARD = "dashboard";
export const STORE_DASHBOARD = "store_dashboard";

export const ORDERS_MANAGEMENT = "orders_management";
export const ORDERS_DELIVERY = "orders_delivery";
export const ORDERS_SUB_EXPORT_DATA = "orders_sub_export_data";

export const MASTER_CATALOG_BRAND = "master_catalog_brand";
export const MASTER_CATALOG_PRODUCT = "master_catalog_products";
export const MASTER_CATALOG_DISPLAY_CATEGORY = "master_catalog_display_category";
export const MASTER_CATALOG_COUPONS = "master_catalog_coupons";

export const BRANCH_CATALOG_PRODUCT = "branch_catalog_products";
export const BRANCH_CATALOG_DISPLAY_COTEGORY = "branch_catalog_display_category";

export const PROMOTIONS_MANAGEMENT = "promotions_management";

export const HOME_TEMPLATE_MANAGEMENT = "home_template_management";

export const REPORT = "report";

export const PERMISSION = "permission";

export const SHOP_MANAGEMENT = "shop_management";

export const SHOW_ALL_BRANCH = "branch_config_show_all_branch";
